import axiosInstance from './instance';

const instance = axiosInstance();

export const userInformation = async (id) => {
    try {
        const response = await instance.get(`/users/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getIndividualUnivrsity = async (id) => {
    try {
        const response = await instance.get(`/master-data/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}


export const uploadEducationDetails = async (data) => {
    try {
        const response = await instance.post(`/users/educational-details`, data);
        return response;
    } catch (error) {
        return error;
    }
}


export const updateEducationalDetails = async (data) => {
    try {
        const response = await instance.put(`/users/educational-details/${data.id}`, data);
        return response;
    } catch (error) {
        return error;
    }

}

export const getUserWorkDetails = async (userId) => {
    try {
        const response = await instance.get(`users/workexperience/user/${userId}`);
        return response;
    } catch (error) {
        return error;
    }

}

export const createUserWorkDetails = async (workDetails) => {
    try {
        const response = await instance.post(`users/workexperience`, workDetails);
        return response;
    } catch (error) {
        return error;
    }

}

export const updateUserWorkDetails = async (details) => {
    try {
        const response = await instance.put(`users/workexperience/${details.id}`, details);
        return response;
    } catch (error) {
        return error;
    }

}
export const getAllStudentsView = async (role,page,size) => {
    try {
        const response = await instance.get(`/all-users?role=${role}&page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }

}
export const getAllStudentsViewWithSorting = async (role,page,size,sorter) => {
    try {
        const response = await instance.get(`/all-users?role=${role}&page=${page}&size=${size}&sort=${sorter.fieldName},${sorter.direction}`);
        return response;
    } catch (error) {
        return error;
    }

}
export const searchUsers = async (role,data,page,size) => {
    try {
        const response = await instance.post(`${role}/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }

}